import { render, staticRenderFns } from "./IconTimeV52.vue?vue&type=template&id=21a1530b"
import script from "./IconTimeV52.vue?vue&type=script&lang=js"
export * from "./IconTimeV52.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports